import React, { useEffect, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import DataTable from "react-data-table-component";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
  BidAll,
  BidAllData,
  BidWinnerList,
  BidWinnerListData,
  ManagerGetAll,
} from "../../redux/auth-reducer/auth-service";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import * as icons from "react-bootstrap-icons";
import { useLocation } from "react-router-dom";

export const Bid = () => {
  const [data, setData] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchTextWin, setSearchTextWin] = useState("");
  const [itemList, setItemList] = useState();
  const [itemDataBidWin, setItemDataBidWin] = useState([]);
  const [listBid, setListBid] = useState([]);
  const [allManager, setAllManager] = useState([]);
  const [selectedManagerId, setSelectedManagerId] = useState("");
  const [filteredData, setFilteredData] = useState(itemList);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  const [key, setKey] = useState(() => {
    return localStorage.getItem("activeTabWinner") || "BidAlll";
  });

    const location = useLocation();

  useEffect(() => {
    localStorage.setItem("activeTabWinner", key);
  }, [key]);

   useEffect(() => {
    if (location.state && location.state.targetTab) {
      setKey(location.state.targetTab);
    }
  }, [location.state]); 


  const sidebarfun = () => {
    setData(!data);
  };
  const handleSelectChange = (event) => {
    setSelectedManagerId(event.target.value);
  };

  useEffect(() => {
    const getAllManagers = async () => {
      await ManagerGetAll().then((res) => {
        setAllManager(res?.data?.data?.dataList);
      });
    };
    getAllManagers();
  }, []);

  const columns = [
    {
      name: "Id",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Auction Name",
      selector: (row) => row?.auctionName,
      sortable: true,
    },
    {
      name: "Team Name",
      selector: (row) => row?.teamName,
      sortable: true,
      width: "250px",
    },

    {
      name: "Bid Time Limit",
      selector: (row) => row?.bidTime,
      sortable: true,
    },
    {
      name: "Starting Bid",
      selector: (row) => row?.startingBid,
      sortable: true,
    },
    {
      name: "Bid Increment",
      selector: (row) => row?.bidIncrement,
      sortable: true,
    },
    {
      name: "Current Bid",
      selector: (row) => row?.currentBidAmount,
      sortable: true,
    },
    {
      name: "Auction Created By",
      selector: (row) => row?.createdByName,
      sortable: true,
    },
    {
      name: "Total Bids",
      selector: (row) => row?.totalPlacedBids,
      sortable: true,
    },
  ];

  const columns2 = [
    {
      name: "Id",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Auction Name",
      selector: (row) => row?.auctionName,
      sortable: true,
    },
    {
      name: "Team Name",
      selector: (row) => row?.teamName,
      sortable: true,
    },
    {
      name: "Bid Amount",
      selector: (row) => row?.bidAmount,
      sortable: true,
    },

    {
      name: "Bid Status",
      selector: (row) => row?.status,
      sortable: true,
    },
  ];

  const getAdminData = async (data) => {
    try {
      const response = await BidAllData(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []);
        setListBid(response?.data?.data?.dataList); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  // useEffect(() => {
  //   const data = {
  //     "PageNumber": currentPage,
  //     "PageSize": perPage
  //   };
  //   getAdminData(data); // Fetch data when currentPage changes
  // }, [currentPage]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: true,
    };
    getAdminData(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  const handlePerPageChange1 = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: true,
    };
    BidWinFn(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearchWin = (e) => {
    setSearchTextWin(e.target.value);
  };

  useEffect(() => {
    const filteredItems = itemList?.filter((item) => {
      const matchesManager = selectedManagerId
        ? item?.createdBy === parseInt(selectedManagerId)
        : true;
      const matchesSearchText = searchText
        ? item?.auctionName
            ?.toLowerCase()
            .includes(searchText?.toLowerCase()) ||
          item?.teamName?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.createdByName?.toLowerCase().includes(searchText?.toLowerCase())
        : true;

      return matchesManager && matchesSearchText;
    });

    setFilteredData(filteredItems);
  }, [itemList, searchText, selectedManagerId]);

  // useEffect(() => {

  //     const BidWinFn = async () => {
  //         await BidWinnerList().then((response) => {

  //             setItemDataBidWin(response?.data);
  //         })

  //     }
  //     BidWinFn();

  // }, []);

  const BidWinFn = async (data) => {
    try {
      const response = await BidWinnerListData(data); // Call your API function
      if (response?.data) {
        setItemDataBidWin(response.data.data.dataList || []);
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const filteredDataWin = searchTextWin
    ? itemDataBidWin.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchTextWin?.toLowerCase()) ||
          item?.teamName
            ?.toLowerCase()
            .includes(searchTextWin?.toLowerCase()) ||
          item?.createdBy?.toLowerCase().includes(searchTextWin?.toLowerCase())
        );
      })
    : itemDataBidWin;

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: true,
    };
    if (key === "BidAlll") {
      getAdminData(data); // Fetch data for BidAll when currentPage changes
    } else if (key === "Winner" || 'BidWon') {
      BidWinFn(data); // Fetch data for Winner when currentPage changes
    }
  }, [currentPage, key]); // Add activeTab to the dependency array

  const handleSelect = (key) => {
     setKey(key);
    // setActiveTab(key);
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: true,
    };
    if (key === "BidAlll") {
      getAdminData(data); // Fetch data for BidAll when the tab is selected
    } else if (key === "Winner" || 'BidWon') {
      BidWinFn(data); // Fetch data for Winner when the tab is selected
    }
  };

  // Initial data fetch when the component mounts
  useEffect(() => {
    const initialData = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: true,
    };
    if (key === "BidAlll") {
      getAdminData(data); // Fetch data for BidAll when the tab is selected
    } else if (key === "Winner" || 'BidWon') {
      BidWinFn(data); // Fetch data for Winner when the tab is selected
    } // Fetch initial data for BidAll
  }, []);

  const clearSearch = () => {
    setSearchText("");
  };
  const clearSearchWin = () => {
    setSearchTextWin("");
  };

  
  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Bid History</h1>

          <div className="group_data_table">
            <div className="group_data_table tabs-auction bidAllData ">
              <div className="tabs-box">
                <Tabs
                  id="auctiontabs"
                  activeKey={key}
                  // onSelect={(k) => setKey(k)}
                  onSelect={handleSelect}
                  className="mb-0 tab-list-item"
                  justify
                >
                  <Tab eventKey="BidAlll" className="mt-3" title="ALL">
                    <div>
                      <div className="search-input bid-search filter d-flex align-items-center stickey-parent-div">
                        <label className="sort-status">Filter By</label>

                        <Form.Select
                          name="gender"
                          className="me-4"
                          required
                          as="select"
                          onChange={handleSelectChange}
                        >
                          <option>Select</option>
                          {allManager?.map((manager) => (
                            <option
                              key={manager?.managerId}
                              value={manager?.managerId}
                            >
                              {manager?.firstName} {manager?.lastName}
                            </option>
                          ))}
                        </Form.Select>

                        <input
                          type="text"
                          className="form-control mb-3 mt-3"
                          placeholder="Search..."
                          value={searchText}
                          onChange={handleSearch}
                        />
                        {searchText && (
                          <button
                            className="btn btn-clear"
                            onClick={clearSearch}
                          >
                            <span>&times;</span>{" "}
                            {/* This represents the close icon */}
                          </button>
                        )}
                      </div>

                      <div>
                        <DataTable
                          title="Sport List"
                          columns={columns}
                          data={filteredData}
                          paginationPerPage={perPage}
                          paginationTotalRows={totalRows * 10}
                          paginationDefaultPage={currentPage}
                          onChangePage={setCurrentPage}
                        />
                        {totalRows > 1 && (
                          <Row>
                            <Col md={12} className="text-right">
                              <div className="pagination-controls">
                                <label>Rows per page: </label>
                                <select
                                  id="itemsPerPage"
                                  value={perPage}
                                  onChange={handlePerPageChange}
                                >
                                  {pageOptions.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <Button
                                  onClick={handlePreviousPage}
                                  disabled={currentPage === 1}
                                >
                                  <icons.ArrowLeft></icons.ArrowLeft>
                                </Button>
                                <span>
                                  {currentPage} of {totalRows}{" "}
                                </span>
                                <Button
                                  onClick={handleNextPage}
                                  disabled={currentPage >= Math.ceil(totalRows)}
                                >
                                  <icons.ArrowRight></icons.ArrowRight>
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey="Winner" className="mt-3" title="Winner">
                    <div className="search-input filter d-flex align-items-center">
                      <input
                        type="text"
                        className="form-control mb-3 mt-3"
                        placeholder="Search..."
                        value={searchTextWin}
                        onChange={handleSearchWin}
                      />
                      {searchTextWin && (
                        <button
                          className="btn btn-clear"
                          onClick={clearSearchWin}
                        >
                          <span>&times;</span>{" "}
                          {/* This represents the close icon */}
                        </button>
                      )}
                    </div>

                    <div>
                      <DataTable
                        title="Sport List"
                        columns={columns2}
                        data={filteredDataWin}
                        paginationPerPage={perPage}
                        paginationTotalRows={totalRows * 10}
                        paginationDefaultPage={currentPage}
                        onChangePage={setCurrentPage}
                      />
                      {totalRows > 1 && (
                        <Row>
                          <Col md={12} className="text-right">
                            <div className="pagination-controls">
                              <label>Rows page: </label>
                              <select
                                id="itemsPerPage"
                                value={perPage}
                                onChange={handlePerPageChange1}
                              >
                                {pageOptions.map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>

                              <Button
                                onClick={handlePreviousPage}
                                disabled={currentPage === 1}
                              >
                                <icons.ArrowLeft></icons.ArrowLeft>
                              </Button>
                              <span>
                                {currentPage} of {totalRows}{" "}
                              </span>
                              <Button
                                onClick={handleNextPage}
                                disabled={currentPage >= Math.ceil(totalRows)}
                              >
                                <icons.ArrowRight></icons.ArrowRight>
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
